// extracted by mini-css-extract-plugin
export default {"background":"Timer_background__xKOFU","timerSelect":"Timer_timerSelect__n+MG8"};